export const CART_TOKEN_COOKIE_KEY = 'cart-token'
export const CART_TOKEN_HEADER_KEY = 'X-Cart-Token'

export const PRODUCT_LINE_ITEM_TYPE = 'product'
export const GWP_LINE_ITEM_TYPE = 'gwp'
export const SAMPLE_LINE_ITEM_TYPE = 'free_sample'
export const REDEEMABLE_LINE_ITEM_TYPE = 'redeemable'
export const INSIDER_GIFT_LINE_ITEM_TYPE = 'loyalty_gift'
export const DISCOUNT_COUPON_LINE_ITEM_TYPE = 'discount_coupon'
export const PROMOTION_LINE_ITEM_TYPE = 'promotion'

export const CART_LINE_ITEM_TYPES = [
  PRODUCT_LINE_ITEM_TYPE,
  GWP_LINE_ITEM_TYPE,
  SAMPLE_LINE_ITEM_TYPE,
  REDEEMABLE_LINE_ITEM_TYPE,
  INSIDER_GIFT_LINE_ITEM_TYPE,
  PROMOTION_LINE_ITEM_TYPE,
  DISCOUNT_COUPON_LINE_ITEM_TYPE,
] as const

export const FREE_LINE_ITEM_TYPES = [
  PROMOTION_LINE_ITEM_TYPE,
  DISCOUNT_COUPON_LINE_ITEM_TYPE,
  INSIDER_GIFT_LINE_ITEM_TYPE,
  REDEEMABLE_LINE_ITEM_TYPE,
] as const

export const CART_EXCLUSIVE_OFFERS_SHIPPING_METHOD_SOURCES = 'shipping_method'
export const CART_EXCLUSIVE_OFFERS_PROGRESS_SOURCES = 'progress'
export const CART_EXCLUSIVE_OFFERS_CART_SOURCES = 'cart_message'
export const CART_EXCLUSIVE_OFFERS_COUNTDOWN_TIMER_SOURCES = 'countdown_timer'
export const CART_EXCLUSIVE_OFFERS_LOYALTY_TIER_SOURCES = 'loyalty_tier'
export const CART_EXCLUSIVE_OFFERS_SHIPPING_TIER_SOURCES = 'shipping_tier'

export const CART_EXCLUSIVE_OFFERS_SOURCES = [
  CART_EXCLUSIVE_OFFERS_SHIPPING_METHOD_SOURCES,
  CART_EXCLUSIVE_OFFERS_PROGRESS_SOURCES,
  CART_EXCLUSIVE_OFFERS_CART_SOURCES,
  CART_EXCLUSIVE_OFFERS_COUNTDOWN_TIMER_SOURCES,
  CART_EXCLUSIVE_OFFERS_LOYALTY_TIER_SOURCES,
  CART_EXCLUSIVE_OFFERS_SHIPPING_TIER_SOURCES,
] as const

export const LINE_ITEM_QUANTITY_LIMIT = 6
